export const markAsContacted = {
  urlNotValid: "URL is not Valid",
  emailNotValid: "Email is not Valid",
  numberNotValid: "Phone Number is not Valid",
  notLinkedinUrl: "Linkedin Url is not Valid",
  success: "Expert Marked as Contacted Successfully",
  contactMediumSource: "Contact Medium Source is Required",
};
